import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from 'App'
import Header from 'components/Header/Header'
import axios from 'axios'
import './style.css'
import { requestData } from 'data/request'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';
import { toast } from 'react-toastify'
import { ReactComponent as ArrowDown } from 'assets/Common/arrowDown.svg'

const Request = () => {
  const { isTablet } = useContext(GlobalContext)
  const [isShow, SetIsShow] = useState<boolean>(false);
  const [select, setSelect] = useState<number>(0);
  const [tab, setTab] = useState<number>(0);
  const [once, setOnce] = useState<boolean>(true);

  const menu = [
    { title: requestData[0].title, value: requestData[0].id },
    { title: requestData[1].title, value: requestData[1].id },
    { title: requestData[2].title, value: requestData[2].id },
    { title: requestData[3].title, value: requestData[3].id },
    { title: requestData[4].title, value: requestData[4].id },
    { title: requestData[5].title, value: requestData[5].id },
  ];

  const [info, setInfo] = useState({
    content: '',
    company: '',
    name: '',
    tel: '',
  })

  const [clear, setClear] = useState<boolean>(false);
  const [clearMo, setClearMo] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      SetIsShow(false)
    }, 200)
  }, [select])

  useEffect(() => {
    info.company && info.content && info.name && info.tel ? setClear(true) : setClear(false)
  }, [info])

  useEffect(() => {
    console.log('tab >>>', tab)
    if (tab === 0) {
      setClearMo(true)
    }
    else if (tab === 1) {
      info.content ? setClearMo(true) : setClearMo(false)
    }
    else if (tab === 2) {
      info.company && info.name && info.tel ? setClearMo(true) : setClearMo(false)
    }
    else {
      setClearMo(false)
    }
  }, [info, tab])

  const goDiscord = () => {
    if (once) {
      setOnce(false)
      const msg = {
        avatar_url: 'http://tinslab.co.kr/static/img/logo.svg',
        username: 'TINS LAB',
        content: 'TINS LAB홈페이지 문의',
        discription: '',
        embeds: [
          {
            color: 4539203,
            title: "TINS LAB 프로젝트 문의",
            fields: [
              {
                name: "Company Name",
                value: info.company,
              },
              {
                name: "Name",
                value: info.name,
              },
              {
                name: "Phone",
                value: info.tel,
              },
              {
                name: "Project Type",
                value: requestData[select].title,
              },
              {
                name: "Project Content",
                value: info.content,
              },
            ],
          }
        ],
      }

      postDiscord(msg).then(res => {
        toast.success('정상적으로 문의등록을 완료했습니다.')
        setSelect(0)
        setInfo({
          content: '',
          company: '',
          name: '',
          tel: '',
        })
        isTablet && setTab(0)
        setOnce(true)
      }).catch(err => console.log(err))
    }
  }

  const goPrev = () => {
    if (tab === 2) {
      setTab(tab - 1);
      setInfo({
        ...info,
        company: '',
        name: '',
        tel: ''
      })
    }
    else if (tab === 1) {
      setTab(tab - 1);
      setInfo({
        ...info,
        content: '',
      })
    }
  }

  const goNext = () => {
    if (tab !== 2) {
      setTab(tab + 1);
    }
    else {
      goDiscord();
    }
  }

  return (
    <div className='bg-black'>
      <Header isOverLay={false} />
      {/* PC */}
      <section className='tablet:hidden flex flex-col justify-center py-35 h-full min-h-screen select-none container'>
        <motion.p
          className="mb-7 text-60 text-white"
          style={{ textShadow: '0 0 14px white' }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          PROJECT CONTACT
        </motion.p>

        <div className='flex'>
          <div className='flex-[3]'>
            {
              !isShow &&
              <>
                <div className='mb-11'>
                  {
                    <motion.img
                      className='mb-8 font-semibold text-40 text-black'
                      src={requestData[select].background}
                      alt="컨텍트1"
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                    </motion.img>
                  }
                </div>

                <div className='flex flex-col items-center gap-7'>
                  <div className='flex items-center gap-4 mb-4'>
                    <motion.p
                      className="font-semibold text-white text-2xl"
                      transition={{ delay: 0.2 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      {requestData[select].title}
                    </motion.p>
                    <motion.p
                      className='font-semibold text-[#767676] text-2xl'
                      transition={{ delay: 0.2 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      {requestData[select].titleEn}
                    </motion.p>
                  </div>

                  <div className='flex flex-col gap-4'>
                    <div>
                      {
                        requestData[select].description.map((item, idx) => (
                          <motion.p
                            className='text-white'
                            key={idx}
                            transition={{ delay: (0.2 + 0.1 * idx) }}
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {item}
                          </motion.p>
                        ))
                      }
                    </div>
                    <div>
                      {
                        requestData[select].list.map((item, idx) => (
                          <motion.p
                            className='text-[#A8A8A8]'
                            key={idx}
                            transition={{ delay: (0.4 + 0.1 * idx) }}
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {item}
                          </motion.p>
                        ))
                      }
                    </div>
                  </div>

                  <div className='flex flex-col gap-2 w-full max-w-[440px]'>
                    <motion.div
                      className='flex justify-center items-center bg-[#111111] py-4 rounded-lg w-full'
                      transition={{ delay: 0.6 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      <p className='text-white text-lg'>
                        영업 이메일 : sales@tinslab.co.kr
                      </p>
                    </motion.div>
                  </div>
                </div>
              </>
            }
          </div>

          <div className='flex flex-col flex-1 justify-between bg-[#0E0E0E] px-10 py-9'>
            <div className='flex justify-between items-center mb-4'>
              <p className='font-semibold text-white text-lg'>프로젝트 유형</p>
              <p className='text-#929292'>프로젝트 유형을 선택해주세요</p>
            </div>

            <div className='relative bg-[#fff] mb-6 rounded-lg w-full'>
              <select
                style={{ resize: 'none' }}
                className='bg-[#fff] p-5 rounded-lg w-full text-black'
                onChange={(e) => {
                  SetIsShow(true);
                  setSelect(Number(e.target.value))
                }}
                value={select}
              >
                {
                  menu.map((item, idx) => (
                    <option key={idx} value={item.value}>{item.title}</option>
                  ))
                }
              </select>
              <ArrowDown className='top-7 right-6 absolute' />
            </div>

            <div className='w-full'>
              <p className='pb-4 font-semibold text-white text-lg'>프로젝트 내용</p>
              <textarea
                style={{ resize: 'none' }}
                className='bg-[#5C5C5C] mb-6 p-5 rounded-lg w-full h-45'
                placeholder='프로젝트에 대한 간략한 설명을 작성해주세요.'
                onChange={(e) => {
                  setInfo({
                    ...info,
                    content: e.target.value
                  })
                }}
                value={info.content}
              />
            </div>

            <div>
              <p className='pb-2 font-semibold text-white text-lg'>회사명</p>
              <input
                type="text"
                className='bg-[#5C5C5C] mb-4 p-5 rounded-lg w-full'
                placeholder='회사명을 입력해주세요'
                onChange={(e) => {
                  setInfo({
                    ...info,
                    company: e.target.value
                  })
                }}
                value={info.company}
              />
            </div>

            <div>
              <p className='pb-4 font-semibold text-white text-lg'>담당자 성함</p>
              <input
                type="text"
                className='bg-[#5C5C5C] mb-4 p-5 rounded-lg w-full'
                placeholder='담당자 성함을 입력해주세요'
                onChange={(e) => {
                  setInfo({
                    ...info,
                    name: e.target.value
                  })
                }}
                value={info.name}
              />
            </div>

            <div className='mb-11'>
              <p className='pb-4 font-semibold text-white text-lg'>담당자 연락처</p>
              <input
                type="text"
                className='bg-[#5C5C5C] mb-4 p-5 rounded-lg w-full'
                placeholder='담당자 연락처를 ‘-’를 제외하고 입력해주세요'
                onChange={(e) => {
                  setInfo({
                    ...info,
                    tel: e.target.value
                  })
                }}
                value={info.tel}
              />
            </div>

            <div className={`${clear ? 'bg-[#2C2C2C] cursor-pointer' : 'bg-[#6e6e6e] cursor-not-allowed'} py-5 w-56 rounded-lg justify-items-center self-center select-none`}
              onClick={() => {
                clear ? goDiscord() : toast.error('내용을 채워주세요')
              }}>
              <p className='font-semibold text-white text-lg'>
                보내기
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 태블릿 */}
      <section className='hidden tablet:block relative h-screen select-none'>
        {
          !isShow &&
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className='w-full h-full'
            style={{
              backgroundImage: `url(${requestData[select].backgroundMo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'top',
              backgroundRepeat: 'no-repeat',
              width: '100%',
              height: '100%',
            }}
          ></motion.div>
        }

        {
          !isShow &&
          <motion.div
            initial={{ maxHeight: 0 }}
            animate={{ maxHeight: "600px" }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="bottom-0 left-0 absolute bg-[rgba(0,0,0,0.8)] w-full overflow-hidden"
          >
            {
              tab === 0 &&
              <>
                <div className='p-6 min-h-[276px]'>
                  <div className='flex items-center gap-4 mb-4'>
                    <motion.div
                      className="bg-[#556EF2] w-3 h-3"
                      transition={{ delay: 0.2 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                    </motion.div>
                    <motion.p
                      className="font-semibold text-white text-base"
                      transition={{ delay: 0.2 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      {requestData[select].title}
                    </motion.p>
                    <motion.p
                      className='font-semibold text-[#767676] text-base'
                      transition={{ delay: 0.2 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      {requestData[select].titleEn}
                    </motion.p>
                  </div>

                  <div className='flex flex-col gap-4 mb-4'>
                    <div>
                      <motion.p
                        className='text-white text-sm'
                        transition={{ delay: (0.2) }}
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY} >
                        {requestData[select].description}
                      </motion.p>
                    </div>

                    <div className='flex flex-col gap-2'>
                      {
                        requestData[select].list.map((item, idx) => (
                          <motion.p
                            className='text-[#A8A8A8] text-xs'
                            key={idx}
                            transition={{ delay: (0.4 + 0.1 * idx) }}
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {item}
                          </motion.p>
                        ))
                      }
                    </div>
                  </div>

                  <div className='flex justify-between w-full'>
                    <motion.span
                      className='flex-1 text-white text-xs'
                      transition={{ delay: 0.6 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY} >
                      영업 이메일
                      <div>sales@tinslab.co.kr</div>
                    </motion.span>
                  </div>
                </div>

                <div className='bg-[#0E0E0E] px-6 pt-4'>
                  <div className='flex justify-between items-center mb-2'>
                    <p className='font-semibold text-white text-sm'>프로젝트 유형</p>
                    <p className='text-#929292 text-sm'>프로젝트 유형을 선택해주세요</p>
                  </div>

                  <div className='relative bg-[#fff] rounded-lg'>
                    <select
                      style={{ resize: 'none' }}
                      className='bg-[#fff] p-4 rounded-lg w-full text-black text-sm'
                      onChange={(e) => {
                        SetIsShow(true);
                        setSelect(Number(e.target.value))
                      }}
                      value={select}
                    >
                      {
                        menu.map((item, idx) => (
                          <option key={idx} value={item.value}>{item.title}</option>
                        ))
                      }
                    </select>
                    <ArrowDown className='top-6 right-6 absolute' />
                  </div>
                </div>
              </>
            }

            {
              tab === 1 &&
              <>
                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    프로젝트 유형
                  </motion.p>
                  <motion.div
                    className='bg-[#313131] p-4 rounded-lg w-full text-black text-sm'
                    transition={{ delay: (0.1) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <p className='text-white text-sm text-center'>{menu.filter(arr => arr.value === select)[0].title}</p>
                  </motion.div>
                </div>

                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    transition={{ delay: (0.2) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    프로젝트 내용
                  </motion.p>
                  <motion.div
                    className='w-full'
                    transition={{ delay: (0.3) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <textarea
                      style={{ resize: 'none' }}
                      className='bg-[#5C5C5C] p-5 rounded-lg w-full h-45'
                      placeholder='프로젝트에 대한 간략한 설명을 작성해주세요.'
                      onClick={() => setTimeout(() => {
                        window.scrollTo({
                          top: document.body.scrollHeight,
                          behavior: 'smooth'
                        })
                      }, 200)}
                      onChange={(e) => {
                        setInfo({
                          ...info,
                          content: e.target.value
                        })
                      }}
                      value={info.content}
                    />
                  </motion.div>
                </div>
              </>
            }

            {
              tab === 2 &&
              <>
                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    프로젝트 유형
                  </motion.p>
                  <motion.div
                    className='bg-[#313131] p-4 rounded-lg w-full text-black text-sm'
                    transition={{ delay: (0.1) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <p className='text-white text-sm text-center'>{menu.filter(arr => arr.value === select)[0].title}</p>
                  </motion.div>
                </div>

                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    회사명
                  </motion.p>
                  <motion.div
                    className='w-full'
                    transition={{ delay: (0.1) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <input
                      type="text"
                      className='bg-[#5C5C5C] p-4 rounded-lg w-full text-white text-sm'
                      placeholder='회사명을 입력해주세요'
                      onChange={(e) => {
                        setInfo({
                          ...info,
                          company: e.target.value
                        })
                      }}
                      value={info.company}
                    />
                  </motion.div>
                </div>
                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    담당자 성함
                  </motion.p>
                  <motion.div
                    className='w-full'
                    transition={{ delay: (0.1) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <input
                      type="text"
                      className='bg-[#5C5C5C] p-4 rounded-lg w-full text-white text-sm'
                      placeholder='담당자 성함을 입력해주세요'
                      onChange={(e) => {
                        setInfo({
                          ...info,
                          name: e.target.value
                        })
                      }}
                      value={info.name}
                    />
                  </motion.div>
                </div>

                <div className='flex flex-col justify-between items-start gap-2 bg-[#0E0E0E] px-6 pt-4'>
                  <motion.p
                    className='font-semibold text-white text-sm'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    담당자 연락처
                  </motion.p>
                  <motion.div
                    className='w-full'
                    transition={{ delay: (0.1) }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <input
                      type="text"
                      className='bg-[#5C5C5C] p-4 rounded-lg w-full text-white text-sm'
                      placeholder='담당자 연락처를 ‘-’를 제외하고 입력해주세요'
                      onChange={(e) => {
                        setInfo({
                          ...info,
                          tel: e.target.value
                        })
                      }}
                      value={info.tel}
                    />
                  </motion.div>
                </div>
              </>
            }
            <div className='z-10 relative flex justify-end gap-2 bg-[#0E0E0E] px-6 py-4'>
              {
                tab !== 0 ?
                  <div className='flex justify-center items-center bg-[#313131] py-4 rounded-md w-1/2' onClick={() => goPrev()}>
                    <p className='text-[#898989] tex-sm'>
                      뒤로가기
                    </p>
                  </div> :
                  <div className='w-1/2'></div>
              }
              <button
                className='flex justify-center items-center bg-[#556EF2] disabled:bg-[#313131] py-4 rounded-md w-1/2'
                disabled={!clearMo}
                onClick={() => goNext()}
              >
                <p className='text-white tex-sm'>
                  {
                    tab === 0 ?
                      '문의하기' :
                      tab === 1 ?
                        '다음' :
                        '보내기'
                  }
                </p>
              </button>
            </div>
          </motion.div>
        }
      </section>
    </div>
  )
}

export default Request


export const discord = (userinfo: any | undefined, content: string, endPoint: string, reqData: object | undefined, errorLog: any) => {

}

const postDiscord = async (reqData: any) => {
  return await axios.post('https://discord.com/api/webhooks/1331822196351434752/2DidIeixpQe-raMOApqDvp58KbkjpVkD5KjZ2PKucRfQWhX3lPYQIm9WjlgYf9QfN0co', reqData);
}